import { Injectable } from '@angular/core';
import { MenuItem } from 'mm-web-core/layout/definition/menu-item.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuServiceService {

  constructor() { }

  private menuSubject = new Subject<Array<MenuItem>>();

  public receiveMessage(message: Array<MenuItem>): void {
    this.menuSubject.next(message);
  }

  public getObservable(): Observable<Array<MenuItem>> {
    return this.menuSubject.asObservable();
  }

}
